import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate('/', { replace: true });
      return;
    }
    const session_id = decodeURIComponent(match[1]);

    (async () => {
      try {
        const res = await axios.post(
          `${API}/auth/session`,
          { session_id },
          { withCredentials: true }
        );
        setUser(res.data.user);
        // Remove fragment from URL
        window.history.replaceState({}, '', window.location.pathname);
        navigate('/profile', { replace: true, state: { user: res.data.user } });
      } catch (e) {
        navigate('/', { replace: true });
      }
    })();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen bg-[#F4EFE7] flex items-center justify-center">
      <div className="text-[#1E1B18]/70 text-sm tracking-[0.2em]">SIGNING YOU IN…</div>
    </div>
  );
};

export default AuthCallback;
